module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_lipss.db0ca5e0.png";